export const fullName = (user) => {
  return (user?.first_name ?? "") + " " + (user?.last_name ?? "");
};

export const initials = (user) => {
  return (user?.first_name?.[0] ?? "") + (user?.last_name?.[0] ?? "");
};
